import React from "react";
import { IIconProps } from "./iconProps";

const DeleteIcon: React.FC<IIconProps> = (props) => {
  return (
    <svg {...props} viewBox="0 0 23.109 27.331">
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        data-name="Icon feather-trash-2"
        transform="translate(-3.5 -2)"
      >
        <path d="M4.5 8.066h21.109" data-name="Path 106"></path>
        <path
          d="M23.076 8.066V25.8a2.422 2.422 0 01-2.292 2.533H9.325A2.422 2.422 0 017.033 25.8V8.066m3.438 0V5.533A2.422 2.422 0 0112.763 3h4.584a2.422 2.422 0 012.292 2.533v2.533"
          data-name="Path 107"
        ></path>
        <path d="M12.709 14.399v7.6" data-name="Path 108"></path>
        <path d="M17.4 14.399v7.6" data-name="Path 109"></path>
      </g>
    </svg>
  );
};

export default DeleteIcon;
